import LoguinForm from '../../components/organismos/LoguinForm/LoguinForm'

function Loguin() {
  return (
    <>
      <LoguinForm/>
    </>
  )
}

export default Loguin